import { useCallback } from 'react';
import api from '@/lib/api';
import useCartLogic from '@/shared/checkout/useCartLogic';

/**
 * Wrapper CRM do `useCartLogic` partilhado — apenas injecta os endpoints
 * `/api/encomendas/cart/*`.
 */
export default function useCart() {
  const fetchCart = useCallback(async () => {
    const { data } = await api.get('/encomendas/cart');
    return data?.success ? (data.data || []) : [];
  }, []);

  const addItem = useCallback(async (id_produto, quantidade) => {
    await api.post('/encomendas/cart/add', { id_produto, quantidade });
  }, []);

  const updateQty = useCallback(async (id_carrinho, quantidade) => {
    await api.post('/encomendas/cart/updateQty', { id_carrinho, quantidade });
  }, []);

  const removeItem = useCallback(async (id_carrinho) => {
    await api.post('/encomendas/cart/remove', { id_carrinho });
  }, []);

  return useCartLogic({ fetchCart, addItem, updateQty, removeItem });
}
